import {
	FETCH_CONFIG_BEGIN,
	FETCH_CONFIG_SUCCESS,
	FETCH_CONFIG_FAILURE,
} from '../actions/fetchConfiguration'

const initialState = {
	configuration: [],
	loading: false,
	error: null,
}

export default function fetchConfigurationReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_CONFIG_BEGIN:
			// Request begin: set loading true
			return {
				...state,
				loading: true,
				currentLanguage: action.payload,
				error: null
			}

		case FETCH_CONFIG_SUCCESS:
			// Request success: set loading false, set config data
			return {
				...state,
				loading: false,
				configuration: action.payload
			}

		case FETCH_CONFIG_FAILURE:
			// Request failed: set loading false, save & display error
			return {
				...state,
				loading: false,
				error: action.payload.error,
				configuration: [],
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fetchConfigurationReducers.js